module.exports = __webpack_public_path__ + "img/13.1cf5299b.jpg";